<template>
    <div class="position-relative">
        <p v-if="message && !embed_url" class="ds-alert">
            <span v-html="message"></span>&nbsp;<a v-if="reload_process" href="javascript:void(0);" @click="reloadDS()">Try again</a>
        </p>
        <div class="ds-wrap">
            <iframe v-show="embed_url" :src="embed_url" ref="embed"></iframe>
        </div>
        <p v-if="message && embed_url" class="ds-alert alert-bottom">
            <span v-html="message"></span>&nbsp;<a v-if="reload_process" href="javascript:void(0);" @click="reloadDS()">Try again</a>
        </p>
    </div>
</template>

<script>
export default {
    data() {
        return {
            message: 'Loading DocuSign..',
            reload_process: null,
            embed_url: null,
            DSReady: false,
            DSEnvelopeId: null,
            DSEnvelopeStatus: null,
            DSAttemptLimit: 10,
            DSAttemptInterval: 5000,
            DSAttemptWaitCompletedLimit: 30,
            DSRequestTokenAttempt: 0,
            DSCreateEnvelopeAttempt: 0,
            DSViewDocumentAttempt: 0,
            DSCheckEnvelopeStatusAttempt: 0,
            DSWaitEnvelopeCompleted: 0
        }
    },
    props: {
        start: String,
        survey_id: Number
    },
    watch: {
        start() {
            this.createDSEnvelope()
        }
    },
    mounted() {
        this.requestDSToken()
        this.$emit('status', this.DSEnvelopeStatus)

        // update DS token every 1 hour
        setInterval(() => {
            this.requestDSToken()
        }, (1000*60*60))
    },
    methods: {
        requestDSToken() {
            this.$http.post('/api/ds/requestDSToken', { })
                .then(response => {
                    if(response.data.status == 'ok') {
                        this.DSReady = true
                    }
                })
                .catch(error => {
                    if(this.DSRequestTokenAttempt == 0 || this.DSRequestTokenAttempt == this.DSAttemptLimit) {
                        this.dsErrorLog('request_token', error.response.data)
                    }

                    if(this.DSRequestTokenAttempt < this.DSAttemptLimit) {
                        setTimeout(() => {
                            this.DSRequestTokenAttempt++
                            this.requestDSToken()
                        }, this.DSAttemptInterval)
                    }
                    
                    this.DSReady = false
                })
        },
        createDSEnvelope() {
            if(this.DSCreateEnvelopeAttempt == 0) {
                this.reload_process = null
                this.message = 'Loading DocuSign...'
                this.embed_url = null
                this.DSEnvelopeId = null
                this.DSEnvelopeStatus = null
            }

            if(this.DSReady) {
                this.$http.post('/api/ds/createDSEnvelope', { survey_id: this.survey_id })
                    .then(response => {
                        if(response.data.status == 'ok') {
                            this.DSEnvelopeId = response.data.envelopeId
                            this.DSEnvelopeStatus = response.data.envelopeStatus
                            this.viewDSDocument()
                        } else if(response.data.status == 'no_documents') {
                            this.message = '<div style="font-size: 16px; font-weight: bold;">No DocuSign, proceed to next step now.</div>'
                            this.DSEnvelopeStatus = 'completed'
                            this.$emit('status', this.DSEnvelopeStatus)
                        }
                    })
                    .catch(error => {
                        if(this.DSCreateEnvelopeAttempt == 0 || this.DSCreateEnvelopeAttempt == this.DSAttemptLimit) {
                            this.dsErrorLog('create_envelope', error.response.data)
                        }

                        if(this.DSCreateEnvelopeAttempt < this.DSAttemptLimit) {
                            setTimeout(() => {
                                this.DSCreateEnvelopeAttempt++
                                this.createDSEnvelope()
                            }, this.DSAttemptInterval)
                        }
                        
                        this.reload_process = 'create_envelope'
                        this.message = 'Failed to load DocuSign, report has been logged.'
                        this.DSReady = false
                    })
            } else {
                setTimeout(() => {
                    this.dsErrorLog('create_envelope', 'No token yet.')
                    this.reload_process = 'create_envelope'
                    this.message = 'Failed to load DocuSign, report has been logged.'
                }, this.DSAttemptInterval)
            }
        },
        viewDSDocument() {
            if(this.DSViewDocumentAttempt == 0) {
                this.reload_process = null
                this.message = 'Retrieving documents...'
            }

            this.$http.post('/api/ds/viewDSDocument', { survey_id: this.survey_id })
                .then(response => {
                    if(response.data.status == 'ok') {
                        this.message = null
                        this.embed_url = response.data.url
                        this.$refs.embed.onload = () => {
                            this.DSWaitEnvelopeCompleted = 0
                            this.getDSEnvelopeStatus()
                        }
                    }
                })
                .catch(error => {
                    if(this.DSViewDocumentAttempt == 0 || this.DSViewDocumentAttempt == this.DSAttemptLimit) {
                        this.dsErrorLog('view_document', error.response.data)
                    }

                    if(this.DSViewDocumentAttempt < this.DSAttemptLimit) {
                        setTimeout(() => {
                            this.DSViewDocumentAttempt++
                            this.viewDSDocument()
                        }, this.DSAttemptInterval)
                    }
                    
                    this.reload_process = 'view_document'
                    this.message = 'Failed to load DocuSign, report has been logged.'
                    this.embed_url = null
                })
        },
        getDSEnvelopeStatus() {
            if(this.DSCheckEnvelopeStatusAttempt == 0) {
                this.reload_process = null
            }

            this.$http.post('/api/ds/getDSEnvelopeStatus', { survey_id: this.survey_id })
                .then(response => {
                    if(response.data.status == 'ok') {
                        this.DSEnvelopeStatus = response.data.envelopeStatus
                        
                        if(this.DSEnvelopeStatus == 'sent' || this.DSEnvelopeStatus == 'delivered') { 
                            this.message = 'Sign the document, Click FINISH, and wait for next step to show.'

                            if(this.DSWaitEnvelopeCompleted == this.DSAttemptWaitCompletedLimit) {
                                this.reload_process = 'check_envelope_status'
                                this.message = 'Took too long to complete the process, report has been logged.'
                                this.dsErrorLog('check_envelope_status', 'Took too long to complete.')
                            }
                
                            if(this.DSWaitEnvelopeCompleted < this.DSAttemptWaitCompletedLimit) {
                                setTimeout(() => {
                                    this.getDSEnvelopeStatus()
                                    if((this.DSWaitEnvelopeCompleted + 1) <= this.DSAttemptWaitCompletedLimit) {
                                        this.DSWaitEnvelopeCompleted++
                                    }
                                }, this.DSAttemptInterval)
                            }
                        
                        } else if(this.DSEnvelopeStatus == 'declined') {
                            this.message = 'You declined to sign the documents above.'
                        } else if(this.DSEnvelopeStatus == 'voided') {
                            this.message = 'The document has been voided. For more information please contact the administrator.'
                        } else if(this.DSEnvelopeStatus == 'completed') {
                            this.message = '<div style="font-size: 16px; font-weight: bold;">Confirmed, proceed to next step now.</div>\
                                            <div style="font-size: 4em; color: #459e45;"><span class="fa fa-check-circle"></span></div>'
                            this.embed_url = null
                        } else {
                            this.message = 'Please sign the documents above, click FINISH, and wait for DocuSign confirmation.'
                        }
                    }
                    this.$emit('status', this.DSEnvelopeStatus)
                })
                .catch(error => {
                    if(this.DSCheckEnvelopeStatusAttempt == 0 || this.DSCheckEnvelopeStatusAttempt == this.DSAttemptLimit) {
                        this.dsErrorLog('check_envelope_status', error.response.data)
                    }

                    if(this.DSCheckEnvelopeStatusAttempt < this.DSAttemptLimit) {
                        setTimeout(() => {
                            this.DSCheckEnvelopeStatusAttempt++
                            this.getDSEnvelopeStatus()
                        }, this.DSAttemptInterval)
                    }
                    
                    this.reload_process = 'check_envelope_status'
                    this.message = 'Failed to confirm status, report has been logged.'
                    this.$emit('status', this.DSEnvelopeStatus)
                })
        },
        dsErrorLog(process, error) {
            this.$http.post('/api/ds/errorLog', {
                survey_id: this.survey_id,
                process: process,
                error: error
            })
        },
        reloadDS() {
            if(this.reload_process) {
                this.DSRequestTokenAttempt = 0
                this.DSCreateEnvelopeAttempt = 0
                this.DSViewDocumentAttempt = 0
                this.DSCheckEnvelopeStatusAttempt = 0
                this.DSWaitEnvelopeCompleted = 0

                switch(this.reload_process) {
                    case 'create_envelope':
                        if(!this.DSReady) {
                            this.requestDSToken()
                        }
                        this.createDSEnvelope()
                    break;
                    case 'view_document':
                        this.viewDSDocument()
                    break;
                    case 'check_envelope_status':
                        this.getDSEnvelopeStatus()
                    break;
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.ds-wrap {
    width: 100%;
    height: 500px;
    position: relative;
    iframe {
        width: 100%;
        height: 100%;
    }
}
.ds-alert {
    text-align: center;
    width: 100%;
    position: absolute;
    top: 15em;
    margin: 0;
    z-index: 100;
    &.alert-bottom {
        top: unset;
        position: relative;
        color: #8a6d3b;
        background-color: #fcf8e3;
        border-color: #faebcc;
        padding: 7px 15px;
        text-align: left;
    }
}
</style>